import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from '@core/services/storage.service';
@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _storage: StorageService) {
  }
  async canActivate(): Promise<boolean> {
    if (await this.isAdminSession()) {
      await this._router.navigate(['/drivers']);
      return false;
    } else {
      return true;
    }
  }
  private isAdminSession(): Promise<boolean> {
    return this._storage.get('tokenLogin').then((token: string) => !!token);
  }
}
